import React from 'react';
import PropTypes from 'prop-types';

const Button = ({ text, onClick, className, type }) => {
  return (
    <button
      // @ts-ignore
      type={type}
      onClick={onClick}
      className={`button ${className || ''}`}
    >
      {text}
    </button>
  );
};

Button.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  className: PropTypes.string,
  type: PropTypes.oneOf(['button', 'submit', 'reset'])
};

Button.defaultProps = {
  onClick: () => {},
  className: '',
  type: 'button'
};

export default Button;